import { render, staticRenderFns } from "./CRUDQuadros.vue?vue&type=template&id=83adf294&"
import script from "./CRUDQuadros.vue?vue&type=script&lang=js&"
export * from "./CRUDQuadros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports